import styled from "styled-components";

export default styled.footer`
  /* height: 72px; */
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;
